import styled from "styled-components";
import Image1 from "../../public/images/afredfest/event-info-card-image-1.png";
import Image2 from "../../public/images/afredfest/event-info-card-image-2.png";
import Image3 from "../../public/images/afredfest/event-info-card-image-3.png";
import Image4 from "../../public/images/afredfest/event-info-card-image-4.png";
import { InfoCard } from "./event-info-card"; // Assuming InfoCard is in the same directory

const conferenceData = [
   {
      id: "01",
      title: "Keynote Addresses",
      items: [
         "Cultural Identity in a Globalized World: Raising African Children with Pride.",
         "The Future of African Education: Preparing for Success in the UK and Beyond.",
      ],
      imageAlt: "children-jumping", // Replace with actual image path
      image: Image1,
      bgColor: "#DBECFF",
   },
   {
      id: "02",
      title: "Panel Discussions",
      items: [
         "Balancing Heritage & Modernity: The Role of African Culture in Child Education.",
         "Navigating The UK Education System as an African Parent.",
         "Mental Health Race & Identity: Supporting African Children in a Diverse Society.",
      ],
      imageAlt: "balanced-rocks", // Replace with actual image path
      image: Image2,
      bgColor: "#E2DBFF",
   },
   {
      id: "03",
      title: "Networking Session",
      items: [
         "Connect & Share African Parenting And Education Networking Event.",
         "Opportunities For African Students In The UK: Scholarships, Internships, & Mentorship Programs.",
      ],
      imageAlt: "networking", // Replace with actual image path
      image: Image3,
      bgColor: "#FFE9CA",
   },
   {
      id: "04",
      title: "Workshop Session",
      items: [
         "Strategies For Academic Success.",
         "Raising Resilient Children: Coping With Racial Discrimination in UK Schools.",
         "Financial Planning For African Families: Investing in Your Child's Education.",
      ],
      imageAlt: "strategy", // Replace with actual image path
      image: Image4,
      bgColor: "#CAD2FF",
   },
];

const InfoCardList = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
   gap: 2rem;
   margin-top: 2rem;
   margin-bottom: 4rem;
   @media screen and (min-width: 768px) {
      grid-template-columns: repeat(auto-fit, minmax(375px, 1fr));
      gap: 4rem;
   }
`;

export const EventSchedule: React.FC = () => {
   return (
      <InfoCardList className="event-schedule">
         {conferenceData.map((session) => (
            <InfoCard
               key={session.id}
               number={session.id}
               bgColor={session.bgColor}
               title={session.title}
               items={session.items}
               imageAlt={session.imageAlt}
               image={session.image}
            />
         ))}
      </InfoCardList>
   );
};
